import { useEffect } from 'react';

interface TooltipInstance {
  dispose: () => void;
}
interface NioGlobal {
  initTooltips?: (root?: Element | Document) => TooltipInstance[];
}

/**
 * Bootstrap tooltips are initialized once when the template bundle executes —
 * which happens on the first marketing mount, before SPA-navigated pages
 * exist. Pages with tooltips (e.g. pricing) call this to (re)initialize them
 * for their own DOM once the Nio bundle is available, and dispose on unmount.
 */
export function useBrightSaaSTooltips() {
  useEffect(() => {
    let instances: TooltipInstance[] = [];

    const init = () => {
      const nio = (window as unknown as { Nio?: NioGlobal }).Nio;
      if (nio?.initTooltips) instances = nio.initTooltips(document);
    };

    if ((window as unknown as { Nio?: NioGlobal }).Nio?.initTooltips) {
      init();
    } else {
      window.addEventListener('brightsaas:loaded', init, { once: true });
    }

    return () => {
      window.removeEventListener('brightsaas:loaded', init);
      instances.forEach((t) => t.dispose());
    };
  }, []);
}
